import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import getOrgById from '../hooks/getOrgById';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import SideBar4 from '../components/Sidebar/SideBar4';
import useFetchOrganizations from '../hooks/fetchOrganizations';
// import useFetchRoles from '../hooks/fetchRoles';
import useFetchPermissions from '../hooks/fetchPermissions';
import { Pagination, Input } from 'antd';
import { app } from '../config';
import useFetchTransactions from '../hooks/fetchTransactions';
import useFetchTransactionsByOrg from '../hooks/fetchTransactions By Org';
import { dateConverter } from '../utils/utcDateConversion';

const Orgdonations = () => {
  const { Search } = Input;
  const { t } = useTranslation(['common']);
  let navigate = useNavigate();
  let user = JSON.parse(localStorage.getItem('user'));
  console.log(user);
  let tr = useFetchTransactionsByOrg(user.organizationId);
  console.log(tr);
  let donations = tr.response ? tr.response.data : null;
  console.log(donations);
  let donationCount = tr.response ? tr.response.data.length : 0;

  // let permCount = perm.response?perm.response.length:"";
  // let permResponse=[];
  // console.log('🚀 ~ file: Permissions.js:16 ~ Permissions ~ perm', perm.response);
  const [editbtn, setEditBtn] = useState('none');
  const [search, setSearch] = useState('');
  const [donation,setDonations]=useState([]);
  const [current, setCurrent] = useState(1);
  const [searchShow, setSearchShow] = useState(false);
  const [renderList, setRenderList] = useState([]);
  const [tableShow, setTableShow] = useState(true);
  const [err, setErr] = useState('');
  let searchedUser;
  const editPerm = (e) => {
    console.log(e);
    localStorage.setItem('permissionId', JSON.stringify(e.permId));
    navigate('/permission/edit', { replace: true });
  };
  const onSearch = (value) => console.log(value);
  useEffect(() => {
    if (user.userType === 'A') setEditBtn('block');
    const fetchDonations = async () => {
      const limit = 1000;
      const offset = 0;
      const donationRes = await axios.post(`${app.URL}/trans/viewbyorg/${user.organizationId}`, { limit, offset });
      console.log(donationRes);
      console.log(donationRes.data);
      const convertedObj = donationRes.data ? dateConverter(donationRes.data.data, 'donationDate') : [];
      console.log(convertedObj);
      donationRes.data? setDonations(convertedObj) : console.log('donation not set');
      donationRes.data ? setRenderList(convertedObj.slice(0,10)) : console.log('Not Set');

    };
    fetchDonations();
  }, []);
  const handleSearch = async () => {
    try {
      const result = search ? await axios.get(`${app.URL}/user/search/${search}`) : [];
      searchedUser = result.data;
    } catch (e) {
      console.log('Error');
      if (e.message) setErr(e.response.data.message);
      setTableShow(false);
    }

    console.log(searchedUser);
    if (searchedUser) {
      setSearchShow(true);
      setRenderList(searchedUser);
    }
    console.log(searchedUser);
  };
  const handleSearchChange = (e) => {
    if (!e.target.value) {
      setRenderList(permResponse.data);
      setTableShow(true);
    }
    setSearch(e.target.value);
  };
  // useEffect(() => {
  //   if (!searchShow) setRenderList(permResponse.data);
  // }, [handleSearch]);
  console.log(editbtn);
  const onChange = async (page, pageSize) => {
    console.log(page, pageSize);
    setCurrent(page);
    if (!page) page = 1;
    let limit = pageSize;
    let reqObj = {
      limit,
      offset: limit * (page - 1),
    };
    console.log(reqObj);
    setRenderList(donation.slice(reqObj.offset, reqObj.offset + limit));
  };
  return (
    <div class='ml-3 col-lg-12 col-md-12 col-sm-12'>
    <div className='row text-center mt-3'>
      <div className='col-lg-11 col-md-11 col-sm-11'>
        <Search
          placeholder='Search donations'
          onSearch={onSearch}
          size="large"
          style={{
            width: 300,
          }}
        />
      </div>
    </div>
    <div className='row'>
      <div className='col-lg-12 col-md-12 col-sm-12 '>
        <div class='mt-4 fs-3 fw-bold'> {t('Donations')} </div>
      </div>
    </div>
    <div className='row'>
      <div class='col-lg-11'>
        <div class='styled-table  '>
          {/* style={{display:tableShow?"block":"none"}} */}
          <table class='table '>
            <thead class='thead-light'>
              <tr>
                <th>{t('Organization')}</th>
                <th>{t('Donation Date')}</th>
                <th>{t('Cause')}</th>
                <th>{t('Donation')}</th>
                <th>{t('Donor Name')}</th>
              </tr>
            </thead>
            <tbody>
              {renderList
                ? renderList.map((output) => (
                    <tr>
                      <td>{output.organizationName}</td>
                      <td>{output.donationDate}</td>
                      <td>{output.cause}</td>
                      <td>{output.amount}</td>
                      <td>{output.donorName}</td>
                      {editbtn === 'block' ? (
                        <td>
                          <button type='button' style={{ display: editbtn }} class='btn btn-primary color1 button' onClick={() => editPerm(output)}>
                            {t('Edit')}
                          </button>
                        </td>
                      ) : (
                        ' '
                      )}
                    </tr>
                  ))
                : ' '}
            </tbody>
          </table>
        </div>
      </div>
      <Pagination style={{marginTop:"10px"}} onChange={onChange} defaultCurrent={current} pageSize={10} total={donation.length} />  
    </div>
  </div>
  );
};

export default Orgdonations;
